export default __webpack_public_path__ + "static/economic-performance-banner-6ee562a70efb9ece6d152a965803f1ca.png";